var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { BodyTemplate, CardWithTabs, EntireLoader, ManagerPermissionContent } from 'renderer/components';
import { MANAGER_PERMISSION_ACTIONS, MANAGER_PERMISSION_KEYS, MANAGER_PERMISSION_PRIORITY } from 'renderer/models';
import { StatByDuration, StatMain } from './components';
import { ManagerQuery, StoreQuery } from 'renderer/queries';
import { useWindowSize } from 'renderer/utils/hooks/window';
var SalesStatistics = function (props) {
    var isPC = useWindowSize().isPC;
    var tabs = [{ tab: '매출 현황', key: 'main' }, isPC && { tab: '매출변동 추이', key: 'duration' }].filter(Boolean);
    var loginManager = ManagerQuery.getLoginManagerInCache();
    var commons = {
        key: MANAGER_PERMISSION_KEYS.STATITCS_SALES,
        action: MANAGER_PERMISSION_ACTIONS.READ
    };
    var readPerm = loginManager === null || loginManager === void 0 ? void 0 : loginManager.hasPermission(__assign(__assign({}, commons), { priority: MANAGER_PERMISSION_PRIORITY.MINE }));
    var readAllPerm = loginManager === null || loginManager === void 0 ? void 0 : loginManager.hasPermission(__assign(__assign({}, commons), { priority: MANAGER_PERMISSION_PRIORITY.ALL }));
    var store = StoreQuery.getMyStoreInCache();
    var children = {
        main: (React.createElement(ManagerPermissionContent, { descriptions: ['상점매출 분석 조회 권한이 없습니다.'], isPrevent: !readPerm, children: readPerm ? (React.createElement(StatMain, { store: store, loginManager: loginManager, readAll: readAllPerm })) : (React.createElement("div", { style: { height: '200px' } })) })),
        duration: (React.createElement(ManagerPermissionContent, { descriptions: ['상점매출 분석 조회 권한이 없습니다.'], isPrevent: !readPerm, children: readPerm ? (React.createElement(StatByDuration, { store: store, loginManager: loginManager, readAll: readAllPerm })) : (React.createElement("div", { style: { height: '200px' } })) }))
    };
    return store ? (React.createElement(BodyTemplate, { title: "\uC0C1\uC810\uB9E4\uCD9C \uBD84\uC11D", content: React.createElement(CardWithTabs, { tabList: tabs, defaultActiveTabKey: "main", children: children }) })) : (React.createElement(EntireLoader, { open: true }));
};
export default SalesStatistics;
